import React from "react";
import { Modal } from "reactstrap";
import { connect } from "react-redux";
import { setLoader } from "../../redux/actions";

class Loader extends React.Component {
  toggle = () => {
    setLoader(!this.props.loader)
  };

  render() {
    return (
      <Modal
        isOpen={this.props.loader}
        size="sm"
        toggle={this.toggle}
        centered={true}
        backdrop={'static'}
        fade={false}
      >
        <div className="loading" />
      </Modal>
    );
  }
};

const mapStateToProps = ({ settings }) => {
  const { loader } = settings
  return { loader };
};

export default connect(
  mapStateToProps, { setLoader }
)(Loader);